import AccordionTextBlock from "@/components/AccordionTextBlock/AccordionTextBlock";
import { ContentBlock } from "@/components/ContentBlock/ContentBlock";
import type { FundDetailLayoutComponentProps } from "@/types/fundDetailLayout";

export const FxImportantInformationPanel = ({ dashboard, flex }: FundDetailLayoutComponentProps) => {
	const { fxImportantInformationPanel: props } = dashboard;
	if (!props) {
		return null;
	}

	return (
		<ContentBlock id="fxImportantInformationPanel" data-testid="FxImportantInformationPanel" flex={flex} width="100%" tabIndex={-1}>
			<AccordionTextBlock {...props} />
		</ContentBlock>
	);
};
